import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { useState, useEffect   } from 'react';
import './App.css';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
import { FaBars, FaChartLine, FaList, FaServer , FaClipboard, FaHome, FaBook, FaUsers, FaChevronDown, FaChevronRight, FaRobot, FaCog, FaTimes, FaTag, FaLink, FaCalendarAlt, FaLayerGroup } from 'react-icons/fa';
// import { CampaignsTable } from './components/Campaigns';  
import { CampaignsTable } from './page/campaigns';  
import List from './page/list'; 
import Servers from './page/servers';
import Reports from './page/reports';
import ChangePassword from './page/change_password';
import Customers from './page/customers';
import SubUsers from './page/subUsers';
import Links from './page/links';
import CustomFields from './page/customFields';
import Tags from './page/tags';
import Members from './page/members';
import Segments from './page/segments';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Login from './page/login';
// import Unsubscribe from './page/unsubscribe';
import Unsubscribed from './page/unsubscribed';
import Subscribed from './page/subscribed'; import Page from './page/page';
import Tracker from './page/tracker';
import TrackingPixel from './page/tracking-pixel';
import Dashboard from './page/dashboard';
import CampaignInfo from './page/campaignInfo';
import Template from './page/template';
import TriggerAutomations from './page/triggerAutomations';
import Events from './page/events';
import CustomerApi from './page/customerApi';
import AdminApi from './page/adminApi';
import ApiLogs from './page/apiLogs';
import ActivityLogs from './page/activityLogs';
import EmailActivityLogs from './page/emailActivityLogs';

function App() {
  const [activeView, setActiveView] = useState('dashboard');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const [userRole, setUserRole] = useState(null);
  const [isSubuser, setIsSubuser] = useState(false);
  const [subuserModules, setSubuserModules] = useState([]);
  const [audienceMenuOpen, setAudienceMenuOpen] = useState(false);
  const [campaignsMenuOpen, setCampaignsMenuOpen] = useState(false);
  const [trackingMenuOpen, setTrackingMenuOpen] = useState(false);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  


  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    if (isAuthenticated) {
      setIsAuthenticated(true);
      setUsername(userData.username || 'User');
      setUserRole(userData.role_id || null);
      setIsSubuser(userData.is_subuser || false);
      
      // Load subuser modules if it's a subuser
      if (userData.is_subuser) {
        const modules = userData.modules || JSON.parse(localStorage.getItem('subuser_modules') || '[]');
        setSubuserModules(Array.isArray(modules) ? modules : []);
      }
      // Note: All users can now access campaigns, so no need to redirect role 2 users
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 320);
    return () => clearTimeout(timer);
  }, [sidebarCollapsed]);

  // Auto-expand Audience menu if one of its children is active
  useEffect(() => {
    if (['list', 'tags', 'members', 'custom-fields', 'segments'].includes(activeView)) {
      setAudienceMenuOpen(true);
    }
  }, [activeView]);

  // Auto-expand Campaigns menu if one of its children is active
  useEffect(() => {
    if (['campaigns', 'links', 'template'].includes(activeView)) {
      setCampaignsMenuOpen(true);
    }
  }, [activeView]);

  // Auto-expand Tracking menu if one of its children is active
  useEffect(() => {
    if (['api-logs', 'activity-logs', 'email-logs'].includes(activeView)) {
      setTrackingMenuOpen(true);
    }
  }, [activeView]);

  // Auto-expand Settings menu if one of its children is active
  useEffect(() => {
    if (['servers', 'events', 'admin-api', 'customer-api'].includes(activeView)) {
      setSettingsMenuOpen(true);
    }
  }, [activeView]);

  // Redirect role 2 users away from restricted views
  useEffect(() => {
    if (userRole === 2) {
      const restrictedViews = ['reports', 'customers'];
      if (restrictedViews.includes(activeView)) {
        setActiveView('dashboard');
      }
    }
  }, [userRole, activeView]);

  // Helper function to check if menu item should be visible for subuser
  const isMenuVisible = (menuId) => {
    if (!isSubuser) return true; // Show all menus for regular users
    if (menuId === 'dashboard') return true; // Always show dashboard
    return subuserModules.includes(menuId); // Show only selected modules
  };

  // Redirect subusers away from restricted views
  useEffect(() => {
    if (isSubuser && activeView !== 'dashboard' && activeView !== 'change-password' && !subuserModules.includes(activeView)) {
      setActiveView('dashboard');
    }
  }, [isSubuser, activeView, subuserModules]);
  
  const renderContent = () => {
    // If subuser, restrict access to only dashboard, change-password, and selected modules
    if (isSubuser) {
      if (activeView !== 'dashboard' && activeView !== 'change-password' && !subuserModules.includes(activeView)) {
        // Show dashboard if trying to access restricted view
        return <div key="dashboard"><Dashboard setActiveView={setActiveView} /></div>;
      }
    }
    
    // If user role is 2, restrict access to certain views
    if (userRole === 2 && !isSubuser) {
      const restrictedViews = ['reports', 'customers'];
      if (restrictedViews.includes(activeView)) {
        // Show dashboard if trying to access restricted view
        return <div key="dashboard"><Dashboard setActiveView={setActiveView} /></div>;
      }
    }

    switch (activeView) {
      case 'campaigns':
        return (
          <div key="campaigns">
            <CampaignsTable />
          </div>
        );
      case 'list':
        return <div key="list"><List /></div>;  
      case 'servers':
        return <div key="servers"><Servers /></div>;
      case 'tags':
        return <div key="tags"><Tags /></div>;
      case 'members':
        return <div key="members"><Members /></div>;
      case 'segments':
        return <div key="segments"><Segments /></div>;
        case 'reports':
          return <div key="reports"><Reports /></div>;
      case 'change-password':
        return <div key="change-password"><ChangePassword /></div>;
      case 'links':
        return <div key="links"><Links /></div>;
      case 'dashboard':
        return <div key="dashboard"><Dashboard setActiveView={setActiveView} /></div>;
      case 'campaignInfo':
        return <div key="campaignInfo"><CampaignInfo /></div>;
      case 'customers':
        return <div key="customers"><Customers /></div>;
      case 'sub-users':
        return <div key="sub-users"><SubUsers /></div>;
      case 'custom-fields':
        return <div key="custom-fields"><CustomFields /></div>;
      case 'template':
        return <div key="template"><Template /></div>;
      case 'trigger-automations':
        return <div key="trigger-automations"><TriggerAutomations /></div>;
      case 'events':
        return <div key="events"><Events /></div>;
      case 'customer-api':
        return <div key="customer-api"><CustomerApi /></div>;
      case 'api-logs':
        return <div key="api-logs"><ApiLogs /></div>;
      case 'activity-logs':
        return <div key="activity-logs"><ActivityLogs /></div>;
      case 'email-logs':
        return <div key="email-logs"><EmailActivityLogs /></div>;
      case 'admin-api':
        return <div key="admin-api"><AdminApi /></div>;
      default:
        return (
          <div key="default">
            <h2>Welcome to Dashboard</h2>
            <p>Select an option from the sidebar to get started.</p>
          </div>
        );
    }
  };

  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
      {isAuthenticated ? (
          <>

        <Navbar bg="light" variant="light" expand="lg" className="app-header">
          <Container fluid className="px-3">
            <Button
              variant="outline-light"
              className="me-2 d-lg-none"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              {mobileMenuOpen ? <FaTimes /> : <FaBars />}
            </Button>
            <Button
              variant="outline-light"
              className="me-2 d-none d-lg-inline-block"
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              aria-label="Toggle sidebar"
            >
              <FaBars />
            </Button>
            <Navbar.Brand href="#home" className="fw-bold">Email Campaigns</Navbar.Brand>
            <Navbar.Toggle aria-controls="navbar-nav" />
            <Navbar.Collapse id="navbar-nav" className="justify-content-end">
              <Navbar.Text className="me-3">
                <span className="d-none d-md-inline">Signed in as: </span>
                <strong>{username}</strong>
              </Navbar.Text>
              
              <Button 
                variant="outline-light" 
                className="ms-2"
                onClick={() => {
                  localStorage.removeItem('isAuthenticated');
                  setIsAuthenticated(false);
                }}
              >
                Logout
              </Button>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div className="d-flex flex-grow-1 layout-container">
          {/* Mobile Overlay */}
          {mobileMenuOpen && (
            <div 
              className="mobile-overlay d-lg-none"
              onClick={() => setMobileMenuOpen(false)}
            />
          )}
          
          <div 
            className={`bg-light border-end sidebar-transition sidebar ${sidebarCollapsed ? 'sidebar-collapsed' : ''} ${mobileMenuOpen ? 'mobile-menu-open' : ''}`} 
            style={{ width: sidebarCollapsed ? '60px' : '250px', minHeight: '100%' }}
          >
            <Nav className="flex-column p-2">

             

              <div className="nav-item position-relative">
                <Nav.Link 
                  href="dashboard" 
                  className={`text-dark d-flex align-items-center nav-link-item ${activeView === 'dashboard' ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveView('dashboard');
                    setMobileMenuOpen(false);
                  }}
                >
                  <FaHome className="me-2 nav-icon" />
                  <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Dashboard</span>
                </Nav.Link>
              </div>



                {/* Show Customers menu only if user role is not 2 and not subuser */}
                {userRole !== 2 && !isSubuser && (
                <div className="nav-item position-relative">
                  <Nav.Link 
                    href="#customers" 
                    className={`text-dark d-flex align-items-center nav-link-item ${activeView === 'customers' ? 'active' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveView('customers');
                      setMobileMenuOpen(false);
                    }}
                  >
                    <i className="fa-solid fa-users me-2 nav-icon"></i>
                    <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Customers</span>
                  </Nav.Link>
                </div>
              )}



              {/* Audience Menu - only show if list, tags, members, custom-fields, or segments is in subuser modules */}
              {(!isSubuser || (isSubuser && (subuserModules.includes('list') || subuserModules.includes('tags') || subuserModules.includes('members') || subuserModules.includes('custom-fields') || subuserModules.includes('segments')))) && (
              <div className="nav-item position-relative">
                <Nav.Link 
                  href="#audience" 
                  className="text-dark d-flex align-items-center justify-content-between nav-link-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!sidebarCollapsed) {
                      setAudienceMenuOpen(!audienceMenuOpen);
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FaUsers className="me-2 nav-icon" />
                    <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Audience</span>
                  </div>
                  {!sidebarCollapsed && (
                    audienceMenuOpen ? <FaChevronDown className="ms-auto chevron-icon" /> : <FaChevronRight className="ms-auto chevron-icon" />
                  )}
                </Nav.Link>
                
                {/* Submenu items */}
                {(!sidebarCollapsed && audienceMenuOpen) && (
                  <div className="submenu ms-4 mt-1">

                     
                    {/* Custom Fields menu - only show if in subuser modules */}
                    {isMenuVisible('custom-fields') && (
                      <Nav.Link 
                        href="#custom-fields" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'custom-fields' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('custom-fields');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaTag className="me-2 nav-icon" />
                        <span>Custom Fields</span>
                      </Nav.Link>
                    )}


                    {isMenuVisible('list') && (
                      <Nav.Link 
                        href="#list" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'list' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('list');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaList className="me-2 nav-icon" />
                        <span>Lists</span>
                      </Nav.Link>
                    )}
                    
                    {isMenuVisible('tags') && (
                      <Nav.Link 
                        href="#tags" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'tags' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('tags');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <i className="fa-solid fa-tags me-2 nav-icon"></i>
                        <span>Tags</span>
                      </Nav.Link>
                    )}
                    
                    {isMenuVisible('members') && (
                      <Nav.Link 
                        href="#members" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'members' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('members');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <i className="fa-solid fa-users me-2 nav-icon"></i>
                        <span>Contacts</span>
                      </Nav.Link>
                    )}

                    {isMenuVisible('segments') && (
                      <Nav.Link 
                        href="#segments" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'segments' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('segments');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaLayerGroup className="me-2 nav-icon" />
                        <span>Segments</span>
                      </Nav.Link>
                    )}
                   


                  </div>
                )}
              </div>
              )}

              {/* Campaigns Menu - only show if any campaigns module is in subuser modules */}
              {(!isSubuser || (isSubuser && (subuserModules.includes('campaigns') || subuserModules.includes('links') || subuserModules.includes('template')))) && (
              <div className="nav-item position-relative">
                <Nav.Link 
                  href="#campaigns-menu" 
                  className="text-dark d-flex align-items-center justify-content-between nav-link-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!sidebarCollapsed) {
                      setCampaignsMenuOpen(!campaignsMenuOpen);
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FaChartLine className="me-2 nav-icon" />
                    <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Campaigns</span>
                  </div>
                  {!sidebarCollapsed && (
                    campaignsMenuOpen ? <FaChevronDown className="ms-auto chevron-icon" /> : <FaChevronRight className="ms-auto chevron-icon" />
                  )}
                </Nav.Link>
                
                {/* Campaigns Submenu items */}
                {(!sidebarCollapsed && campaignsMenuOpen) && (
                  <div className="submenu ms-4 mt-1">


                    {/* Campaigns menu - only show if in subuser modules */}
                    {isMenuVisible('campaigns') && (
                      <Nav.Link 
                        href="#campaigns" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'campaigns' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('campaigns');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaChartLine className="me-2 nav-icon" />
                        <span>Manage Campaigns</span>
                      </Nav.Link>
                    )}

                    {/* Templates menu - only show if in subuser modules */}
                    {isMenuVisible('template') && (
                      <Nav.Link 
                        href="#template" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'template' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('template');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaBook className="me-2 nav-icon" />
                        <span>Templates</span>
                      </Nav.Link>
                    )}
                    


                    {isMenuVisible('links') && (
                      <Nav.Link 
                        href="#links" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'links' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('links');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaLink className="me-2 nav-icon" />
                        <span>Links</span>
                      </Nav.Link>
                    )}
                    
                   
                  </div>
                )}
              </div>
              )}

              {/* Settings Menu - only show if any settings module is in subuser modules */}
              {(!isSubuser || (isSubuser && (subuserModules.includes('servers') || subuserModules.includes('events') || subuserModules.includes('admin-api') || subuserModules.includes('customer-api')))) && (
              <div className="nav-item position-relative">
                <Nav.Link 
                  href="#settings" 
                  className="text-dark d-flex align-items-center justify-content-between nav-link-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!sidebarCollapsed) {
                      setSettingsMenuOpen(!settingsMenuOpen);
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FaCog className="me-2 nav-icon" />
                    <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Settings</span>
                  </div>
                  {!sidebarCollapsed && (
                    settingsMenuOpen ? <FaChevronDown className="ms-auto chevron-icon" /> : <FaChevronRight className="ms-auto chevron-icon" />
                  )}
                </Nav.Link>
                
                {/* Settings Submenu items */}
                {(!sidebarCollapsed && settingsMenuOpen) && (
                  <div className="submenu ms-4 mt-1">
                    {isMenuVisible('servers') && (
                      <Nav.Link 
                        href="#servers" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'servers' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('servers');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaServer className="me-2 nav-icon" />
                        <span>Servers</span>
                      </Nav.Link>
                    )}
                    
                    {isMenuVisible('events') && (
                      <Nav.Link 
                        href="#events" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'events' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('events');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaCalendarAlt className="me-2 nav-icon" />
                        <span>Events</span>
                      </Nav.Link>
                    )}
                    
                    {/* Show Admin API menu only if user role is 1 (admin) and not subuser */}
                    {userRole === 1 && !isSubuser && isMenuVisible('admin-api') && (
                      <Nav.Link 
                        href="#admin-api" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'admin-api' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('admin-api');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <i className="fa-solid fa-key me-2 nav-icon"></i>
                        <span>API's</span>
                      </Nav.Link>
                    )}
                    
                    {/* Show Customer API menu if role is 2 or subuser with customer-api module */}
                    {((userRole === 2 && !isSubuser) || (isSubuser && isMenuVisible('customer-api'))) && (
                      <Nav.Link 
                        href="#customer-api" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'customer-api' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('customer-api');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <i className="fa-solid fa-key me-2 nav-icon"></i>
                        <span>API</span>
                      </Nav.Link>
                    )}
                    
                    {/* Users menu - available for all users except subusers */}
                    {!isSubuser && (
                      <Nav.Link 
                        href="#sub-users" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'sub-users' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('sub-users');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <i className="fa-solid fa-user-group me-2 nav-icon"></i>
                        <span>Users</span>
                      </Nav.Link>
                    )}
                  </div>
                )}
              </div>
              )}



              {/* Trigger Automations - only show if in subuser modules */}
              {isMenuVisible('trigger-automations') && (
                <div className="nav-item position-relative">
                  <Nav.Link 
                    href="trigger-automations" 
                    className={`text-dark d-flex align-items-center nav-link-item ${activeView === 'trigger-automations' ? 'active' : ''}`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveView('trigger-automations');
                      setMobileMenuOpen(false);
                    }}
                  >
                    <FaRobot className="me-2 nav-icon" />
                    <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Trigger Automations</span>
                  </Nav.Link>
                </div>
              )}

              {/* Tracking Menu - only show if any tracking module is in subuser modules */}
              {(!isSubuser || (isSubuser && (subuserModules.includes('api-logs') || subuserModules.includes('activity-logs') || subuserModules.includes('email-logs')))) && (
              <div className="nav-item position-relative">
                <Nav.Link 
                  href="#tracking-menu" 
                  className="text-dark d-flex align-items-center justify-content-between nav-link-item"
                  onClick={(e) => {
                    e.preventDefault();
                    if (!sidebarCollapsed) {
                      setTrackingMenuOpen(!trackingMenuOpen);
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <FaClipboard className="me-2 nav-icon" />
                    <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Logging</span>
                  </div>
                  {!sidebarCollapsed && (
                    trackingMenuOpen ? <FaChevronDown className="ms-auto chevron-icon" /> : <FaChevronRight className="ms-auto chevron-icon" />
                  )}
                </Nav.Link>
                
                {/* Tracking Submenu items */}
                {(!sidebarCollapsed && trackingMenuOpen) && (
                  <div className="submenu ms-4 mt-1">
                    {isMenuVisible('api-logs') && (
                      <Nav.Link 
                        href="#api-logs" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'api-logs' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('api-logs');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaClipboard className="me-2 nav-icon" />
                        <span>API Logs</span>
                      </Nav.Link>
                    )}
                    
                    {isMenuVisible('activity-logs') && (
                      <Nav.Link 
                        href="#activity-logs" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'activity-logs' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('activity-logs');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaClipboard className="me-2 nav-icon" />
                        <span>Activity Logs</span>
                      </Nav.Link>
                    )}
                    
                    {isMenuVisible('email-logs') && (
                      <Nav.Link 
                        href="#email-logs" 
                        className={`text-dark d-flex align-items-center nav-link-item submenu-item ${activeView === 'email-logs' ? 'active' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveView('email-logs');
                          setMobileMenuOpen(false);
                        }}
                      >
                        <FaClipboard className="me-2 nav-icon" />
                        <span>Email Logs</span>
                      </Nav.Link>
                    )}
                  </div>
                )}
              </div>
              )}

              
              <div className="nav-item position-relative">
                <Nav.Link 
                  href="#change-password" 
                  className={`text-dark d-flex align-items-center nav-link-item ${activeView === 'change-password' ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveView('change-password');
                    setMobileMenuOpen(false);
                  }}
                >
                  <i className="fa-solid fa-lock me-2 nav-icon"></i>
                  <span className={sidebarCollapsed ? 'sidebar-text' : ''}>Change Password</span>
                </Nav.Link>
              </div>

             

            

            </Nav>
          </div>
          <div className="main-content">
            <div key={activeView}>
              {renderContent()}
            </div>
          </div>
        </div>
        </>

      ) : (
          <Routes>
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/" element={<Login setAuth={setIsAuthenticated} />} />
            {/* <Route path="/unsubscribe/:email" element={<Unsubscribe />} /> */}
            {/* <Route path="/unsubscribe/:email/:uid" element={<Unsubscribe />} /> */}
            <Route path="/unsubscribed/:uid" element={<Unsubscribed />} />
            <Route path="/subscribed/" element={<Subscribed />} />
            <Route path="/page/:link/:email" element={<Page />} />
            <Route path="/logo/:uid" element={<Tracker />} />

            <Route path="/tracking-pixel/:uid" element={<TrackingPixel />} />
            {/* <Route path="/logo" element={<LogoHandler />} /> */}
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
